<template>
  <li :class="['rounded-lg', backgroundClass]">
    <component :is="button ? DynamicLink : 'div'" :link="button?.link" class="p-8 block">
      <h3 class="text-xl md:text-2xl font-semibold mb-4">{{ content.title }}</h3>
      <RawHtml v-if="content.description" class="text-grey-dark" :html="content.description" />
      <p
        v-if="button?.label"
        class="flex items-center gap-1.5 text-(--main-color) font-semibold mt-5"
      >
        <span>{{ button.label }}</span>
        <IconSprite id="arrow" class="text-[10px]" />
      </p>
    </component>
  </li>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { DynamicLink } from "@/components/small";
import { RawHtml } from "../helpers";
import IconSprite from "@/components/helpers/IconSprite.vue";

export default {
  name: "ContentCard",
  components: { IconSprite, RawHtml },
  setup() {
    return {
      DynamicLink,
    };
  },
  props: {
    background: {
      type: String as PropType<background>,
      required: true,
    },
    content: {
      type: Object as PropType<ContentCard>,
      required: true,
    },
  },
  computed: {
    backgroundClass() {
      return this.background === "white" ? "bg-grey" : "bg-white";
    },
    button() {
      if (!this.content.buttons?.length) return null;

      return this.content.buttons[0];
    },
  },
};
</script>
